let messagesConfig = type =>
  ({
    client: {
      header: [
        { prop: "Нотариус", lg: { span: 6, offset: 2 } },
        { prop: "Сообщение", lg: 11 },
        { prop: "Номер заявки", lg: 4 }
      ],
      getBody: data => ({
        date: { type: "text", prop: data.createdDateString, lg: 2 },
        notary: { type: "user", prop: data.notary.getFullName(), lg: 6 },
        message: { type: "text", prop: data.text, lg: 11 },
        num: { type: "text", prop: data.appointment, lg: 2 },
        link: { type: "link", prop: data.appointment, lg: 2 }
      })
    },
    notary: {
      header: [
        { prop: "Клиент", lg: { span: 5, offset: 2 } },
        { prop: "Сообщение", lg: 12 },
        { prop: "Номер заявки", lg: 4 }
      ],
      getBody: data => ({
        date: { type: "text", prop: data.createdDateString, lg: 2 },
        client: { type: "text", prop: data.client.getFullName(), lg: 5 },
        message: { type: "text", prop: data.text, lg: 12 },
        num: { type: "text", prop: data.appointment, lg: 2 },
        link: { type: "link", prop: data.appointment, lg: 2 }
      })
    }
  }[type]);

export default messagesConfig;
